import React, { useEffect, useState } from 'react';
import CustomModal from './CustomModal';
import './PasteModal.css';

const PasteModal = ({ pasteModalOpen, closeModal, handleSubmitPasteQA }) => { 
  const [input, setInput] = useState([]);
  const [tags, setTags] = useState("");
  const [isError, setIsError] = useState(false); 

  const readFromClipboard = async () => {
    try {
      const data = await navigator.clipboard.readText();
      const json_data = JSON.parse(data);
      setInput(json_data);
      setIsError(false);
    } catch (error) {
      console.error('Error reading from clipboard:', error);
      setIsError(true);
    }
  };

  const handleTagsChange = (e) => {
    setTags(e.target.value);
  };

  useEffect(() => {
    if (pasteModalOpen) {
      readFromClipboard();
    }
  }, [pasteModalOpen]);

  const handleInputChange = (index, key, value) => {
    const newInput = [...input];
    newInput[index][key] = value;
    setInput(newInput);
  };

  return (
    <CustomModal
      isOpen={pasteModalOpen}
      onRequestClose={closeModal}
      overlayClassName="modal-overlay"
      modalClassName="modal-base"
      headerContent={<h3>Paste QA Pairs</h3>}
      bodyContent={
        isError ? 
          <div className="modal-error-message">Malformed JSON or incorrect structure.</div>
        : 
          <div className="paste-modal-body">
            {input.map((item, index) => (
              <div key={index} className="question-answer-pair">
                <label>Question:</label>
                <input 
                  type="text" 
                  value={item.question} 
                  onChange={(e) => handleInputChange(index, 'question', e.target.value)}
                />
                <label>Answer:</label>
                <input 
                  type="text" 
                  value={item.answer} 
                  onChange={(e) => handleInputChange(index, 'answer', e.target.value)}
                />
              </div>
            ))}
          </div>
      }
      footerContent={
        isError ?
          <div className="modal-footer-buttons">
            <button onClick={closeModal}>Close</button>
          </div>
        :
          <div className="modal-footer-content">
            <div className="footer-tags-container">
              <label>Add Tags (Comma Separated):</label>
              <input
                type="text"
                value={tags}
                onChange={handleTagsChange}
              />
            </div>
            <div className="footer-buttons">
              <button onClick={() => handleSubmitPasteQA(input, tags, isError)}>Submit</button>
              <button onClick={closeModal}>Close</button>
            </div>
          </div>
      }     
    />
  );
};

export default PasteModal;
